import React from 'react';
import { fromJS } from 'immutable';

import TrackingModeToggler from 'main/components/show/cuesheet/trackingModeToggler.jsx';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class TrackingSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      onToggleTrackingEnabled,
      onSelectTrackableUser,
      trackingEnabled,
      trackableUsers,
      trackedUserId,
      iconRight,
    } = this.props;

    return (
      <div className="cs-tracking-component">
        {this.props.children}
        <TrackingModeToggler
          toggleLeftValue={trackingEnabled === true}
          users={fromJS(trackableUsers || {})}
          activeUser={fromJS(trackedUserId)}
          onChangeOverride
          onChange={(id) => onSelectTrackableUser(id)}
          onToggleTrackingEnabled={onToggleTrackingEnabled}
          iconRight={iconRight}
        />
      </div>
    );
  }
}

export default TrackingSelector;
